module.exports = __webpack_public_path__ + "img/zagh.567dae4f.jpg";